import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDarkMode from "../../hooks/useDarkMode";
import { login } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { useSelector } from "react-redux";
import { userProfile } from "../../redux/userProfile/action";
import { useForm } from "react-hook-form";
import storePersist from "../../redux/storePersist";
import _ from "lodash";
import { getAccountTypeChannalName } from "../../common/services/common.service";
import { selectChannelListItems } from "../../redux/channel/selector";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import PageLoader from "../../components/PageLoader";
import { toast } from "react-toastify";

export default function TranporterLogin() {
	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	const { height, width } = useWindowDimensions();
	const channelListItem = useSelector(selectChannelListItems)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const { register, handleSubmit, clearErrors, formState: { errors } } = useForm();
	const [loginValues, setLoginValues] = useState<any>()
	const [colorTheme, setTheme] = useDarkMode();
	const [darkSide, setDarkSide] = useState(
		colorTheme === "light" ? true : false
	);
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};
	const toggleDarkMode = (checked: any) => {
		setTheme(colorTheme);
		setDarkSide(checked);
	};

	const handleChange: any = (event: any, field: string) => {
		setLoginValues({ ...loginValues, [field]: event })
	}
	const handleRegistration = () => {
		navigate('/register/rap')
	};
	const gotoHome = (role: any) => {
		switch (role?.toLocaleLowerCase()) {
			case 'rap':
				navigate('/rap/home')
				break;
			default:
				navigate('/auth/login/rap')
		}
	}

	const handleForgotPassword = (e: any) => {
		e.preventDefault();
		storePersist.set('reset-pwd', 'rap')
		navigate('/auth/login/forgot-password')
	}

	const onFinish = async () => {
		try {
			await setIsLoading(true)
			await dispatch(login({
				loginData: {
					"Records": [
						{
							"Context": {
								"Domain": "Mobility",
								"Platform": "iMove",
								"Network": "RAP",
								"Application": "RAP"
							},
							"Message": {
								"Username": loginValues?.Username,
								"Password": loginValues?.Password,
								"AccountType": "RAP",
								"LoginWithOtp": false,
								"Otp": "",
								"IsGoogleAuthenticated": false,
								"AuthenticatedUserId": "",
								"ClientIPAddress": "",
								"OrganizationUnitId": 0
							}
						}
					]

				}
			}))

			const resp: any = await dispatch(userProfile.read({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/user-service/user-profile/me`, entity: 'userProfile' }))
			let selectedRole = ''

			const targetRoles = ['rap']; // Roles to match
			resp.find((element: any) =>
				element?.Message?.Roles.find((role: any) => {
					if (targetRoles.includes(role?.Name?.toLowerCase())) {
						selectedRole = role.Name.toLowerCase();
						return true;
					}
					return false;
				})
			);
			await gotoHome(selectedRole);
			await setIsLoading(false)
		} catch (e: any) {
			toast.error('There was an error in login. Please try again...')
			console.error('Login failed:', e?.Error?.Message);
			await setIsLoading(false)
		}
	};

	useEffect(() => {
		clearErrors('Email')
		clearErrors('Password')
	}, [])

	return (
		<>
			{isLoading ? <PageLoader /> :
				<form onSubmit={handleSubmit(onFinish)} >
					{(width && width < 724) ? <>
						<div className="w-screen h-screen  px-6 ">
							<div className="flex flex-col items-end justify-around h-full">
								<div className="flex flex-col justify-center w-full h-max px-4 shadow px-3">
									<div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
										Log In
										<svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
									</div>
									<div className="w-full my-5">
										<label
											className="block text-sm font-light mb-2" >
											Email Address *
										</label>
										<input
											type="text"
											{...register('Email', {
												required: true,
												pattern:
													/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
											})}
											className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
											placeholder="Email"
											onChange={(event) => {
												handleChange(
													event.target.value,
													'Username'
												);
											}}
											value={loginValues?.Username}
										/>
										{errors.Email && errors.Email.type === "required" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
										)}
										{errors.Email && errors.Email.type === "pattern" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
										)}

									</div>
									<div className="w-full my-5">
										<label
											className="block  text-black text-sm font-light mb-2"
										>
											Password *
										</label>
										<input
											type={showPassword ? 'text' : 'password'}
											{...register('Password', { required: true, maxLength: 30 })}
											className="border-0 px-3 py-3  text-indigo-600    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
											placeholder="Password"
											onChange={(event) => {
												handleChange(
													event.target.value,
													'Password'
												);
											}}
											value={loginValues?.Password}
										/>
										<button
											type="button"
											className="absolute right-10 top-1/2 transform -translate-y-1/2 p-2 pt-12"
											onClick={handleClickShowPassword}

										>
											{showPassword ? (
												<svg
													xmlns="http://www.w3.org/2000/svg"
													fill="none"
													viewBox="0 0 24 24"
													stroke="currentColor"
													className="w-6 h-6"
												>
													<path
														strokeLinecap="round"
														strokeLinejoin="round"
														strokeWidth={2}
														d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
													/>
													<path
														strokeLinecap="round"
														strokeLinejoin="round"
														strokeWidth={2}
														d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
													/>
												</svg>

											) : (
												<svg
													xmlns="http://www.w3.org/2000/svg"
													fill="none"
													viewBox="0 0 24 24"
													stroke="currentColor"
													className="w-6 h-6"
												>
													<path
														strokeLinecap="round"
														strokeLinejoin="round"
														strokeWidth={2}
														d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
													/>
												</svg>

											)}
										</button>
										{errors.Password && errors.Password.type === "required" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
										)}
										{errors.Password && errors.Password.type === "maxLength" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
										)}
									</div>
									<div className="w-full my-5 flex flex-row justify-between mx-3">
										<label className="inline-flex items-center cursor-pointer">
											<input
												id="customCheckLogin"
												type="checkbox"
												className="form-checkbox"
											/>
											<span className="ml-2 text-md text-black">
												Remember me
											</span>
										</label>
										<div className="mr-4">
											<a
												href="#pablo"
												onClick={(e) => { handleForgotPassword(e) }}
												className="text-yellow-500 text-xl"
											>
												<small>Forgot password?</small>
											</a>
										</div>
									</div>
									<div className="text-center mt-6">
										<button type="submit"
											className="bg-black text-white text-xl p-2 w-full">Login</button>


									</div>
									{/* <div className="flex flex-row mt-6 bg-[#FAFAFA] justify-center items-center w-full">
									<img src={require('./../../assets/img/google.jpeg')} className="h-6 w-6" />

									<button
										className=" text-black text-opacity-50 text-xl p-2"
										type="button"
									>
										Sign In with Google
									</button>
								</div> */}
									<div className="w-full flex flex-row justify-center my-3 text-md text-black text-opacity-50">
										<div>Don't have any account ? </div>
										<div onClick={() => handleRegistration()} className="font-normal text-black text-opacity-100 hover:cursor-pointer"> &nbsp;SignUp Free</div>
									</div>
								</div>
							</div>
						</div>
					</> :
						<div className="flex h-screen bg-[#F8F8F8]">
							<div className="container mx-auto px-4 ">
								<div className="flex content-center items-center justify-start h-full">
									<div className="w-1/2 h-max px-6">
										<div className="bg-white flex flex-col items-end justify-around h-full">
											<div className=" justify-center w-full h-screen py-20 px-3">
												<div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
													Log In
													<svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
												</div>
												<div className="w-full my-5">
													<label
														className="block text-sm font-light mb-2" >
														Email Address *
													</label>
													<input
														type="text"
														{...register('Email', {
															required: true,
															pattern:
																/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
														})}
														className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
														placeholder="Email"
														onChange={(event) => {
															handleChange(
																event.target.value,
																'Username'
															);
														}}
														value={loginValues?.Username}
													/>
													{errors.Email && errors.Email.type === "required" && (
														<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
													)}
													{errors.Email && errors.Email.type === "pattern" && (
														<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
													)}

												</div>
												<div className="w-full my-5 relative">
													<label
														className="block  text-black text-sm font-light mb-2"
													>
														Password *
													</label>
													<input
														type={showPassword ? 'text' : 'password'}
														{...register('Password', { required: true, maxLength: 30 })}
														className="border-0 px-3 py-3  text-indigo-600    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
														placeholder="Password"
														onChange={(event) => {
															handleChange(
																event.target.value,
																'Password'
															);
														}}
														value={loginValues?.Password}
													/>
													<button
														type="button"
														className="absolute right-0 top-1/2 transform -translate-y-1/2 p-2 pt-8"
														onClick={handleClickShowPassword}

													>
														{showPassword ? (
															<svg
																xmlns="http://www.w3.org/2000/svg"
																fill="none"
																viewBox="0 0 24 24"
																stroke="currentColor"
																className="w-6 h-6"
															>
																<path
																	strokeLinecap="round"
																	strokeLinejoin="round"
																	strokeWidth={2}
																	d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
																/>
																<path
																	strokeLinecap="round"
																	strokeLinejoin="round"
																	strokeWidth={2}
																	d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
																/>
															</svg>

														) : (
															<svg
																xmlns="http://www.w3.org/2000/svg"
																fill="none"
																viewBox="0 0 24 24"
																stroke="currentColor"
																className="w-6 h-6"
															>
																<path
																	strokeLinecap="round"
																	strokeLinejoin="round"
																	strokeWidth={2}
																	d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
																/>
															</svg>

														)}
													</button>
													{errors.Password && errors.Password.type === "required" && (
														<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
													)}
													{errors.Password && errors.Password.type === "maxLength" && (
														<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
													)}
												</div>
												<div className="w-full my-5 flex flex-row justify-between mx-3">
													<label className="inline-flex items-center cursor-pointer">
														<input
															id="customCheckLogin"
															type="checkbox"
															className="form-checkbox"
														/>
														<span className="ml-2 text-md text-black">
															Remember me
														</span>
													</label>
													<div className="mr-4">
														<a
															href="#pablo"
															onClick={(e) => { handleForgotPassword(e) }}
															className="text-yellow-500 text-xl"
														>
															<small>Forgot password?</small>
														</a>
													</div>
												</div>
												<div className="text-center mt-6">
													<button type="submit"
														className="bg-primary text-light text-xl p-2 w-full">Login</button>


												</div>
												{/* <div className="flex flex-row mt-6 bg-[#FAFAFA] justify-center items-center w-full">
											<img src={require('./../../assets/img/google.jpeg')} className="h-6 w-6" />

											<button
												className=" text-black text-opacity-50 text-xl p-2"
												type="button"
											>
												Sign In with Google
											</button>
										</div> */}
												<div className="w-full flex flex-row justify-center my-3 text-md text-black text-opacity-50">
													<div>Don't have any account ? </div>
													<div onClick={() => handleRegistration()} className="font-normal text-black text-opacity-100 hover:cursor-pointer"> &nbsp;SignUp Free</div>
												</div>
											</div>
										</div>
									</div>
									<div className="w-1/2 h-screen justify-center items-center px-10">
										<img src={require('../../assets/img/TowmanLog.png')} />
									</div>
								</div>
							</div>
						</div >}
				</form >}
		</>
	);
}
